export interface Shipping {
  id: number,
  name: string,
  scac?: string
  canBeIntegrate?: boolean,
}
